import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from "firebase/functions";
import { getRequiredTranslations } from "./getRequiredTranslations";
import { getSupportedLanguagesAry } from "./translate";

export const getTranslations = async (currentStore, col, settingId, key, lang) => {
	const textAry = [];
	const translationsRefs = [];

	const updates = currentStore[col].docs[settingId];
	const update = updates[key];

	if (typeof update?.value === 'object') {
		for (const key of Object.keys(update?.value || {})) {
			if (update.value[key]?.value) {
				textAry.push(update.value[key].value);
				translationsRefs.push(update.value[key].translations);
			}
		}
	} else {
		if (update?.value) {
			if (typeof update.translations !== 'object') {
				update.translations = {};
			}
			textAry.push(update.value);
			translationsRefs.push(update.translations);
		}
	}

	if (textAry.length > 0) {
		const languageDocs = currentStore.settings.docs.languages;
		const requiredTranslations = getRequiredTranslations(languageDocs);
		const { defaultLanguageCode } = getSupportedLanguagesAry(languageDocs);

		const requestData = {
			text: textAry,
			translations: requiredTranslations,
			sourceLanguageCode: lang || defaultLanguageCode,
		};
		console.log({ requestData });

		const functions = getFunctions();

		const callable = httpsCallable(functions, "translateText");
		const translationsResponse = await callable(requestData);

		const translationsResponseAry = translationsResponse.data;

		console.log({ translationsResponseAry });

		// Update each translation reference with the returned translation values.
		for (let i = 0; i < translationsResponseAry.length; i++) {
			const newTrans = translationsResponseAry[i].translations;
			// Update each language key individually, replacing the empty string.
			Object.keys(newTrans).forEach((lang) => {
				translationsRefs[i][lang] = newTrans[lang];
			});
		}

		await setDoc(doc(getFirestore(), `${col}/${settingId}`), updates, {
			merge: false
		});
	}
};
